import React from 'react';
import { INROUTES } from './../../common/links';

const Setting = () => {

return (
  <>
    <section id="container" className="wrap">
    <div className="paragraph">
        <h1 className="subject"><strong>SKYTONE</strong></h1>
        <h2 className="title">기능 설정</h2>
        <p className="desc">
          <span className="bu">- 인터넷 브라우저에 고유 IP를 입력하여 설정 페이지에 진입합니다.</span>
          <span className="bu">- SKYTONE과 <strong>동일한 네트워크 환경(SSID)</strong>에서 시도해야 합니다.</span>
          <span className="bu">- 고유 IP를 잊으셨다면,  <a href={INROUTES.FINDMYDEVICE} target="_blank" rel="noreferrer" className="ic-btn"><button type="button" name="link" value="findmyid">디바이스 주소 찾기</button></a>에서 자세한 내용을 확인해보세요.</span>
        </p>
      </div>
      <div className="page-content">
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">01</p>
            <p className="desc"><strong>인터넷 브라우저</strong>를 열어<br/>주소창에 <strong>고유IP</strong>를 입력하고 접속합니다.</p>
          </div>
          <div className="screenshot">
            <img src={process.env.PUBLIC_URL + '/skytone_src/setting_01.png'} alt=""/>
            <span className="click-area" style={{left:'3%',width:'94%',top:'15%',height:'70%'}}></span>
          </div>              
          <div className="paragraph">
            <p className="desc">만약 고유 IP를 잊으셨다면</p>
            <div className="button-box"><a href={INROUTES.FINDMYDEVICE} target="_blank" rel="noreferrer" className="btn point"><button type="button" name="link" value="findmyid"><strong className="name">디바이스 주소 찾기</strong></button></a></div>
          </div>         
        </div>
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">02</p>
          </div>
          <div className="screenshot w100 filled">
            <img src={process.env.PUBLIC_URL + '/skytone_src/setting_02.png'} alt=""/>
          </div>              
          <div className="paragraph">
            <p className="subj">지역설정</p>
            <p className="desc">대기 정보를 확인하려는 지역을 선택합니다.</p>
            <p className="subj">밝기설정</p>
            <p className="desc">기기의 평소 밝기를 조절할 수 있습니다.</p>
            <p className="subj">야간모드</p>
            <p className="desc">특정 시간대에 밝기를 다르게 설정해 편안한 분위기를 조성할 수 있습니다.</p>
          </div>         
          <div className="paragraph">
            <p className="desc">설정이 완료되면 SAVE 버튼을 눌러 저장합니다.</p>
          </div>         
        </div>
      </div>
    </section>
  </>
  );
};

export default Setting;